<h1 class="sr-only">
  {{ 'my_classroom_economy' | translate }}
</h1>

<section class="homepage-hero">
  <div class="container">
    <div class="homepage-hero__title">
      <p class="homepage-hero__eyebrow c11n-text-sm">
        {{ 'homeV2.eyebrow' | translate }}
      </p>
      <h1>{{ 'homeV2.headline' | translate }}</h1>
      <p class="homepage-hero__description c11n-text-md">
        {{ 'homeV2.description1' | translate }}<strong>{{ 'homeV2.description2' | translate }}</strong>{{ 'homeV2.description3' | translate }}
      </p>
    </div>
    <div class="homepage-hero__cards">
        <hero-card [config]="myceCardConfig"></hero-card>
        <hero-card [config]="myciCardConfig"></hero-card>
    </div>
  </div>
</section>

<section class="why-myce">
  <div class="container">
    <div class="why-myce__content row">
      <div class="why-myce__text col-12 col-lg-6">
        <h2 class="c11n-text-xl-headline mt-0">{{ 'homeV2.why_myce.header' | translate }}</h2>
        <p class="c11n-text-md">{{ 'homeV2.why_myce.description' | translate }}</p>
      </div>
      <div class="why-myce__accordions col-12 col-lg-6">
        <c11n-accordion-group [multiExpandable]="false">
          <c11n-accordion
            [labelText]="'homeV2.why_myce.accordion_0.label' | translate"
            [labelWeight]="'normal'">
            <div accordion-body>
              <p class="c11n-text-md" [innerHTML]="'homeV2.why_myce.accordion_0.content' | translate"></p>
            </div>
          </c11n-accordion>
          <c11n-accordion
            [labelText]="'homeV2.why_myce.accordion_1.label' | translate"
            [labelWeight]="'normal'">
            <div accordion-body>
              <p class="c11n-text-md" [innerHTML]="'homeV2.why_myce.accordion_1.content' | translate"></p>
            </div>
          </c11n-accordion>
          <c11n-accordion
            [labelText]="'homeV2.why_myce.accordion_2.label' | translate"
            [labelWeight]="'normal'">
            <div accordion-body>
              <p class="c11n-text-md" [innerHTML]="'homeV2.why_myce.accordion_2.content' | translate"></p>
            </div>
          </c11n-accordion>
          <c11n-accordion
            [labelText]="'homeV2.why_myce.accordion_3.label' | translate"
            [labelWeight]="'normal'">
            <div accordion-body>
              <p class="c11n-text-md" [innerHTML]="'homeV2.why_myce.accordion_3.content' | translate"></p>
            </div>
          </c11n-accordion>
        </c11n-accordion-group>
      </div>
    </div>
    <div class="row pt-5 why-myce__cards-row">
      <div class="card col-12 col-lg-4 pb-4 pb-lg-0">
        <c11n-card [hasIcon]="true" [hasBorder]="true">
          <img cardIcon [src]="'homeV2.why_myce.cards.card_1.icon' | translate" alt="" aria-hidden="true" />
          <h1 class="mt-0 mb-0" cardHeading>{{ 'homeV2.why_myce.cards.card_1.heading' | translate }}</h1>
          <p cardBody class="mb-0">{{ 'homeV2.why_myce.cards.card_1.body' | translate }}</p>
          <a c11n-link cardAction #cardAction [routerLink]="'homeV2.why_myce.cards.card_1.buttonRoute' | translate | langLink" class="c11n-text-md-bold">{{ 'homeV2.why_myce.cards.card_1.buttonLabel' | translate }}</a>
        </c11n-card>
      </div>
      <div class="card col-12 col-lg-4 pb-4 pb-lg-0">
        <c11n-card [hasIcon]="true" [hasBorder]="true">
          <img cardIcon [src]="'homeV2.why_myce.cards.card_2.icon' | translate" alt="" aria-hidden="true" />
          <h1 class="mt-0 mb-0" cardHeading>{{ 'homeV2.why_myce.cards.card_2.heading' | translate }}</h1>
          <p cardBody class="mb-0">{{ 'homeV2.why_myce.cards.card_2.body' | translate }}</p>
          <a c11n-link cardAction #cardAction [routerLink]="'homeV2.why_myce.cards.card_2.buttonRoute' | translate | langLink" class="c11n-text-md-bold">{{ 'homeV2.why_myce.cards.card_2.buttonLabel' | translate }}</a>
        </c11n-card>
      </div>
      <div class="card col-12 col-lg-4 pb-4 pb-lg-0">
        <c11n-card [hasIcon]="true" [hasBorder]="true">
          <img cardIcon [src]="'homeV2.why_myce.cards.card_3.icon' | translate" alt="" aria-hidden="true" />
          <h1 class="mt-0 mb-0" cardHeading>{{ 'homeV2.why_myce.cards.card_3.heading' | translate }}</h1>
          <p cardBody class="mb-0">{{ 'homeV2.why_myce.cards.card_3.body' | translate }}</p>
          <a c11n-link cardAction #cardAction [routerLink]="'homeV2.why_myce.cards.card_3.buttonRoute' | translate | langLink" [queryParams]="{contact: true}" class="c11n-text-md-bold">{{ 'homeV2.why_myce.cards.card_3.buttonLabel' | translate }}</a>
        </c11n-card>
      </div>
    </div>
  </div>
</section>

<section class="cta-footer" aria-labelledby="cta-headline">
  <div class="container">
    <div class="cta-grid">
      <p class="cta-eyebrow c11n-text-sm">{{ 'homeV2.cta.eyebrow' | translate }}</p>
      <h2 id="cta-headline">{{ 'homeV2.cta.headline' | translate }}</h2>
      <p class="cta-description pt-4 pt-lg-0">{{ 'homeV2.cta.description' | translate }}</p>
    </div>
  </div>
</section>
